<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">账号设置</span>
      </div>
    </div>
    <!-- <div style="text-align: left; margin-bottom: 15px">
      <Tag color="blue">平台提成比例: {{ data.aid_extract }}%</Tag>
      <Tag color="blue"
        >是否开启云知印: {{ data.is_aid ? "开启" : "关闭" }}</Tag
      >
    </div> -->
    <div class="user_box" v-if="!user.role_id">
      <div class="item_title">基本信息</div>
      <Form
        :model="data"
        :label-width="250"
        :rules="rule"
        ref="formData"
        class="form_box"
      >
        <!-- <Row v-if="user.tp === 1">
          <Col span="8">
            <FormItem label="平台交易手续费 (云知印产品):" required>
              <div class="aid_extract">
                <div>
                  <InputNumber
                    v-model="showVal.aid_extract"
                    :max="100"
                    :min="0"
                    disabled
                  ></InputNumber>
                  <span> % </span>
                </div>
              </div>
            </FormItem>
          </Col>
          <Col span="14">
            <FormItem label="平台交易手续费 (云知印mini产品)" required>
              <div class="aid_extract">
                <div>
                  <InputNumber
                    v-model="showVal.dp_extract"
                    :max="100"
                    :min="0"
                    disabled
                  ></InputNumber>
                  <span> % </span>
                </div>
              </div>
            </FormItem>
          </Col>
        </Row> -->
        <FormItem label="合作伙伴账户:" required>
          <Input class="item_form" v-model="data.tel" :disabled="true" />
          <span
            class="btn_text"
            @click="
              modal.visible = true;
              modal.password = '';
            "
            >修改账户密码</span
          >
        </FormItem>
        <FormItem label="合作伙伴名称:" prop="agent_name">
          <Input
            class="item_form"
            :disabled="user.tp != 0"
            v-model="data.agent_name"
            placeholder="请输入合作伙伴单位或个人名称"
          />
        </FormItem>
        <FormItem label="账户负责人:">
          <div>
            <Input
              class="item_form"
              v-model="data.leader_tel"
              placeholder="负责人..."
              disabled
            />
            <span class="btn_text" @click="changeLeader">更换负责人</span>
          </div>
          <div class="describe" style="color: red">
            负责人具有对账户敏感信息操作的权限，如收益分账设置
          </div>
        </FormItem>
        <FormItem label="账户联络人:" prop="contacts_name">
          <Input
            class="item_form"
            v-model="data.contacts_name"
            placeholder="请输入联系人"
          />
        </FormItem>
        <FormItem label="联络人手机号:" prop="contacts_tel">
          <Input
            class="item_form"
            v-model="data.contacts_tel"
            placeholder="请输入手机号"
          />
        </FormItem>
        <FormItem label="服务电话:" prop="service_tel">
          <Input
            class="item_form"
            v-model="data.service_tel"
            placeholder="请输入服务电话"
          />
        </FormItem>

        <FormItem label="联络人邮箱:" prop="email">
          <Input class="item_form" v-model="data.email" placeholder="请输入邮箱" />
        </FormItem>
        <FormItem label="联系地址:" required>
          <div style="display: flex; align-items: center">
            <al-selector
              :gutter="0"
              style="width: 392px"
              data-type="name"
              searchable
              v-model="data.al"
              level="2"
            />
            <Input
              class="item_form"
              style="margin-left: 10px"
              v-model="data.address"
              placeholder="详细地址（请勿重复填入省市区）"
            />
          </div>
        </FormItem>
      </Form>
      <!-- <div class="pageTitle">运维标贴</div> -->
      <Form :model="data" :label-width="120" :rules="rule" class="form_box">
        <!-- <FormItem label="标贴Logo">
          <div class="logo_box" style>
            <div v-if="!data.logo" style="cursor: pointer">
              <input
                type="file"
                ccept="image/png, image/jpeg, image/gif, image/jpg"
                @change="choose"
                class="carousel"
              />
              <p>+ 上传Logo图片</p>
            </div>
            <img v-else :src="data.logo" class="logo" style="max-height: 50px" />
            <span v-if="data.logo" class="del" @click="data.logo = ''">x</span>
          </div>
          <div class="describe">
            标贴logo将被展示在粘贴于设备端的运维标贴上，logo大小支持45*45像数
          </div>
        </FormItem>
        <FormItem label="标题电话">
          <Input
            v-model="data.contacts_telepone"
            placeholder="请填写联络电话"
            maxlength="12"
            class="item_form"
          />
          <div class="describe">
            联络电话将被展示在粘贴于设备端的运维标贴上，提示给客户联系使用
          </div>
        </FormItem>
        <br /> -->

        <div style="padding-left: 50px">
          <Button @click="$router.back()">取消</Button>
          <Button style="margin-left: 10px" type="primary" @click="save">确定</Button>
        </div>
      </Form>
    </div>
    <div v-else class="user_box">
      <Form
        :model="data"
        :label-width="120"
        :rules="rule"
        ref="formData"
        class="form_box"
      >
        <FormItem label="管理员账户:" required>
          <Input class="item_form" v-model="data.tel" :disabled="true" />
          <span
            class="btn_text"
            @click="
              modal.visible = true;
              modal.password = '';
            "
            >修改账户密码</span
          >
        </FormItem>
        <FormItem label="合作伙伴名称:" prop="agent_name">
          <Input
            class="item_form"
            :disabled="user.tp != 0"
            v-model="data.agent_name"
            placeholder="请输入合作伙伴单位或个人名称"
          />
        </FormItem>
      </Form>
    </div>
    <Modal
      width="320"
      title="修改密码"
      v-model="modal.visible"
      :closable="!data.update_password"
      :mask-closable="!data.update_password"
    >
      <Alert v-if="data.update_password" type="error">为了账户安全,请重设密码</Alert>
      <Input v-model="modal.password" placeholder="不得低于6位..." />
      <div slot="footer">
        <Button @click="modal.visible = false">取消</Button>
        <Button type="primary" @click="savePWD">确定</Button>
      </div>
    </Modal>

    <div class="cropperWrap" v-if="cropper.visible">
      <div class="wrapbox">
        <VueCropper
          ref="cropper"
          :img="cropper.preview"
          :autoCropWidth="cropper.autoCropWidth"
          :autoCropHeight="cropper.autoCropHeight"
          :autoCrop="cropper.autoCrop"
          :fixedBox="cropper.fixedBox"
          :outputSize="cropper.outputSize / 100"
          :enlarge="cropper.enlarge"
        ></VueCropper>
        <div class="control">
          <div style="width: 750px">
            图片质量:
            <Slider
              v-model="cropper.outputSize"
              :min="10"
              :step="10"
              :disabled="cropper.preview ? false : true"
            ></Slider>
          </div>
          <Button type="warning" @click="$refs.cropper.rotateLeft()">左转</Button>
          <Button type="primary" style="margin-left: 10px" @click="uploadImage"
            >确定上传</Button
          >
          <Button
            type="warning"
            style="margin-left: 10px"
            @click="$refs.cropper.rotateRight()"
            >右转</Button
          >
          <Button type="error" style="margin-left: 10px" @click="close">关闭</Button>
        </div>
      </div>
    </div>
    <Modal v-model="modalVerify.visible" title="负责人更换" :width="650" footer-hide>
      <div class="modal_verify">
        <div class="title">
          {{
            !modalVerify.isNext
              ? "您正在进行敏感信息操作，为保证资金安全，请进行身份验证！"
              : "请为账户指定新的负责人！"
          }}
        </div>

        <div v-if="!modalVerify.isNext">
          <div class="tip">
            {{
              modalVerify.isCode
                ? "验证码已发送至以下手机号，请注意查收"
                : "点击获取验证码，并正确填入"
            }}
          </div>
          <div class="tel">
            {{ modalVerify.tel }}
            <div class="getCode" v-if="!modalVerify.isCode" @click="getCode(1)">
              获取验证码
            </div>
          </div>
          <div style="height: 130px; padding-top: 20px">
            <div class="input_box" v-if="modalVerify.isCode">
              <Input
                v-model="modalVerify.code"
                class="input"
                size="large"
                placeholder="请正确填入验证码"
              />
              <div class="confirm" @click="confirmVerify">
                确认{{ verifiy.verifiyBtnText }}
              </div>
            </div>
          </div>
        </div>
        <div v-else style="margin: 30px 0 50px">
          <div class="input_box">
            <Input
              v-model="modalVerify.principal_tel"
              class="input"
              size="large"
              placeholder="请填入新负责人手机号"
            />
            <div class="getCode" @click="getCode(2)">
              {{ verifiy.verifiyBtnText }}
            </div>
          </div>
          <div class="input_box" style="margin-top: 15px">
            <Input
              v-model="modalVerify.code"
              class="input"
              size="large"
              placeholder="请正确填入验证码"
            />
            <div class="confirm" @click="savePrincipal">确认</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { VueCropper } from "vue-cropper";
import config from "../../config/index";
export default {
  components: { VueCropper },
  data() {
    var validateTel = function (rule, value, callback) {
      if (!/^1(3|4|5|7|8)\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    return {
      baseUrl: "",
      imgSrc: config.imgSrc,
      data: {
        address: null,
        agent_name: "",
        aid_extract: "",
        dp_extract: "",
        al: [],
        area: null,
        city: null,
        contacts_name: null,
        contacts_tel: null,
        contacts_telepone: null,
        create_time: null,
        email: null,
        id: null,
        user_id: null,
        is_agent: null,
        leader_tel: null,
        logo: null,
        name: null,
        service_tel: null,
        tel: null,
      },
      showVal: {
        aid_extract: 0,
        dp_extract: 0,
      },
      modal: {
        visible: false,
      },
      rule: {
        agent_name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        contacts_name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        contacts_tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validateTel,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        service_tel: [{ required: true, message: "请输入服务电话", trigger: "blur" }],
        address: [
          {
            required: true,
            message: "请完善联系地址",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.data.al && this.data.address) {
                callback();
              } else {
                callback(new Error("请完善联系地址"));
              }
            },
          },
        ],
        bank_name: [{ required: true, message: "请填写开户银行", trigger: "blur" }],
        bank_code: [{ required: true, message: "请填写对公账号", trigger: "blur" }],
        email: [
          { required: true, message: "请填写邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不对", trigger: "blur" },
        ],
      },
      cropper: {
        visible: false,
        preview: "", //预览 base64
        autoCrop: true,
        outputSize: 100, //图片质量
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 400,
        autoCropHeight: 60,
        fileType: "",
        fixedBox: false,
        enlarge: 2,
        canMove: true,
      },
      modalVerify: {
        visible: false,
        isCode: false,
        isNext: false,
        tel: "",
        principal_tel: "",
        code: "",
        data: null,
      },
      verifiy: {
        verifiyBtnText: "获取验证码",
        verifiyTime: 0,
        timer: null,
      },
    };
  },
  mounted() {
    this.data = JSON.parse(JSON.stringify(this.user));
    this.data.al = [this.user.province, this.user.city, this.user.area];
    if (this.data.update_password) {
      this.modal.visible = true;
    }
    this.getUserInfo().then((res) => {
      res.al = [res.province, res.city, res.area];
      this.data = res;
      this.showVal = {
        dp_extract: 100 - res.dp_extract,
        aid_extract: 100 - res.aid_extract,
      };
    });
  },

  created() {
    this.baseUrl =
      process.env.NODE_ENV === "development" ? config.baseUrl.dev : config.baseUrl.pro;
  },
  methods: {
    savePWD() {
      if (!this.modal.password) {
        this.$Message.error("请输入新密码");
        return false;
      }
      if (this.modal.password === "123456") {
        this.$Message.error("新密码不可为初始密码");
        return false;
      }
      let pwdRegex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}");
      if (!pwdRegex.test(this.modal.password)) {
        this.$Message.error("密码必须包含数字和字母，长度不低于6位");
        return false;
      }
      if (this.modal.password.length < 6) {
        this.$Message.error("密码长度不低于6位");
        return false;
      }
      if (!this.user.role_id) {
        this.saveAgent({
          user: { id: this.data.user_id, password: this.modal.password },
          user_agent: { id: this.data.id, name: this.data.name },
        }).then((res) => {
          if (res.status) {
            this.modal.visible = false;
            this.$Message.success("密码修改成功");
            this.FalseUpdPWD();
          }
        });
      } else {
        this.SaveAdminUser({
          id: this.user.role_user_id,
          password: this.modal.password,
        }).then((res) => {
          this.$Message[res.status ? "success" : "error"](
            res.status ? "密码修改成功" : res.msg
          );
          if (res.status) {
            this.modal.visible = false;
          }
        });
      }
    },
    save() {
      console.log("地址", this.data.al);
      if (this.data.al.length < 3 || !this.data.address) {
        this.$Message.error("请完善联系地址");
        return;
      }
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          this.$Message.error("请填写完整数据");
          return false;
        } else {
          let user = {
              id: this.data.user_id,
              name: this.data.agent_name,
            },
            user_agent = {
              id: this.data.id,
              name: this.data.agent_name,
              contacts_name: this.data.contacts_name,
              contacts_tel: this.data.contacts_tel,
              service_tel: this.data.service_tel,
              province: this.data.al[0],
              city: this.data.al[1],
              area: this.data.al[2],
              address: this.data.address,
              email: this.data.email,
              logo: this.data.logo,
              contacts_telepone: this.data.contacts_telepone,
            };
          this.saveAgent({
            user: user,
            user_agent: user_agent,
          }).then((res) => {
            if (res.status) {
              this.$Message.success("保存成功");
              this.$router.back();
            } else {
              this.$Message.error("保存失败,该名称已存在");
            }
          });
        }
      });
    },
    choose(e) {
      let file = e.target.files[0];
      if (file) {
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
          this.$Message.error("仅支持图片文件");
          return;
        }
        this.cropper.visible = true;
        let temp = file.name.split(".");
        this.cropper.fileType = temp[temp.length - 1];
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          console.log(e.currentTarget.result);
          this.cropper.preview = e.currentTarget.result;
        };
      }
    },
    close() {
      this.cropper.visible = false;
    },
    uploadImage() {
      this.$refs.cropper.getCropBlob((data) => {
        data.filename = "a.png";
        if (data.size > 1024 * 1024) {
          this.$Modal.warning({
            title: "图片过大",
            content: "截图区域生成的文件过大,推荐挪动图片或降低图片质量",
          });
          return;
        }
        this.cropper.visible = false;
        let formData = new FormData();
        formData.append("file", data);
        this.SaveAgentLogo(formData).then((res) => {
          this.data.logo = res;
          console.log("logo", res);
        });
      });
    },
    changeLeader() {
      this.modalVerify.visible = true;
      this.data.leader_tel = this.user.leader_tel;
      this.modalVerify.tel =
        this.data.leader_tel.substr(0, 3) + "****" + this.data.leader_tel.substr(7);
      // this.modalVerify.isCode=true;
    },
    getCode(index) {
      if (index == 2 && !this.modalVerify.principal_tel) {
        this.$Message.error("请填入新负责人手机号！");
        return;
      }
      let data = {
        tel: index == 1 ? this.data.leader_tel : this.modalVerify.principal_tel,
        type: 1,
      };

      this.verifiy.time = 60;
      this.verifiy.timer = setInterval(() => {
        if (this.verifiy.time) {
          this.verifiy.time--;
          this.verifiy.verifiyBtnText =
            index == 1 ? `(${this.verifiy.time}s)` : `${this.verifiy.time}s`;
        } else {
          this.verifiy.time = 0;
          this.verifiy.verifiyBtnText = index == 1 ? "" : "获取验证码";
          clearInterval(this.verifiy.timer);
        }
      }, 1000);
      this.SendTelCode(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          if (index == 1) {
            this.modalVerify.isCode = true;
          }
        }
      });
    },
    //验证码验证
    confirmVerify() {
      if (this.modalVerify.code) {
        this.CodeCheck({
          tel: this.data.leader_tel,
          code: this.modalVerify.code,
        }).then((res) => {
          if (res.status) {
            this.modalVerify.isNext = true;
            this.modalVerify.code = "";
            //取消倒计时
            this.verifiy.time = 0;
            this.verifiy.verifiyBtnText = `获取验证码`;
            clearInterval(this.verifiy.timer);
          } else {
            this.$Message["error"]("验证失败");
          }
        });
      } else {
        this.$Message.error("请填入验证码");
      }
    },
    savePrincipal() {
      if (this.modalVerify.code) {
        this.AgentSaveLeader({
          agent_id: this.data.id,
          leader_tel: this.modalVerify.principal_tel,
          code: this.modalVerify.code,
        }).then((res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (res.status) {
            this.modalVerify.visible = false;
            this.data.leader_tel = this.modalVerify.principal_tel;
          }
        });
      } else {
        this.$Message.error("请填入验证码");
      }
    },
    ...mapActions([
      "saveAgent",
      "FalseUpdPWD",
      "SaveAgentLogo",
      "SendTelCode",
      "AgentSaveLeader",
      "CodeCheck",
      "getUserInfo",
      "SaveAdminUser",
    ]),
  },
  computed: mapGetters({
    user: "agent",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
